import { render, staticRenderFns } from "./phoneAddCertificate.vue?vue&type=template&id=4b20f044&scoped=true&"
import script from "./phoneAddCertificate.vue?vue&type=script&lang=js&"
export * from "./phoneAddCertificate.vue?vue&type=script&lang=js&"
import style0 from "./phoneAddCertificate.vue?vue&type=style&index=0&id=4b20f044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20f044",
  null
  
)

export default component.exports